module.exports = __webpack_public_path__ + "img/ptBr.3fc8860c.png";